import React from "react";
import { useDispatch } from "react-redux";
import {
  CHANGE_DCA_PERCENT,
  CHANGE_DCA_TRIGGER,
} from "../../../../actions/create-bot-type";
import DcaMartingaleView from "./DcaMartingaleView";

const DcaPercentEntry = (props) => {
  const { newBot, isBuy,t } = props;
  const dcaTrigger = newBot.dcaTrigger;
  const side = isBuy ? "Buy" : "Sell";
  const dispatch = useDispatch();
  const changeDcaPercent = (val) => {
    dispatch({
      type: CHANGE_DCA_PERCENT,
      payload: val,
    });
  };

  const changeDcaTrigger = (val) => {
    dispatch({
      type: CHANGE_DCA_TRIGGER,
      payload: val,
    });
  };
  return (
    <div>
      <div style={{ marginBottom: 10, fontWeight: "bold" }}>First {side}:</div>
      <div>
        <input
          type="radio"
          name="first_buy"
          value={"0"}
          checked={dcaTrigger === "0"}
          onChange={() => changeDcaTrigger("0")}
          style={{ marginRight: 10 }}
        />
        <label>{side} Immediately when Bot is Created</label>
      </div>
      <div>
        <input
          type="radio"
          name="first_buy"
          value={dcaTrigger}
          checked={dcaTrigger !== "0"}
          onChange={() => changeDcaTrigger("1")}
          style={{ marginRight: 10 }}
        />
        <label>{side} When Price Reaches </label>
        <input
          type="number"
          value={dcaTrigger}
          onChange={(e) => changeDcaTrigger(Number(e.target.value))}
          style={{ marginRight: 10, marginLeft: 10, width: 100 }}
        />
        USD
      </div>
      <div style={{ marginBottom: 10, marginTop: 15, fontWeight: "bold" }}>
        Subsequent {side}s:
      </div>
      <div>
        {side} every time when price {isBuy ? "drops" : "rises"} by{" "}
        <input
          type="number"
          value={newBot.dcaPercent}
          onChange={(e) => changeDcaPercent(e.target.value)}
          style={{ marginRight: 10, marginLeft: 10, width: 50 }}
        />{" "}
        % from last {side} Price
      </div>
      <DcaMartingaleView dcaMartingale={newBot.dcaMartingale} isBuy={isBuy} t={t} />
    </div>
  );
};

export default DcaPercentEntry;
